/* Globals: jQuery, __setCreditCardInfo */

import I4goIframeAbstract from './I4goFrameAbstract';

var i4goIframeSaveUserCard;

(function($) {
    var __setCreditCardPaymentInfo = function(data) {
        var cardTypeMap = {
            AX: 'amex',
            MC: 'mastercard',
            NS: 'discover',
            VS: 'visa',
        };
        var cardType = cardTypeMap[data.i4go_cardtype] ? cardTypeMap[data.i4go_cardtype] : null;
        var preparedData = {
            shift4UniqueId: data.i4go_uniqueid,
            expirationMonth: data.i4go_expirationmonth,
            expirationYear: data.i4go_expirationyear,
            cardNumber: data.cc_number,
            cardType: cardType,
        };

        __setCreditCardInfo(preparedData);
    };

    i4goIframeSaveUserCard = new I4goIframeAbstract({
        formSelector: '#saveUserCard_i4goFrameForm',
        frameContainer: 'saveUserCard_i4goFrame',
        frameAutoResize: false,
        template: undefined,
        label: {
            classes:"control-label col-xs-4 text-right"
        }
    });

    var __postToParent = function(data) {
        var parentWindow = window.parent;
        if (parentWindow === window){
            parentWindow = window.opener;
        }

        var parameters = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            parameters[key] = decodeURIComponent(value);
        });

        if (parameters.parentUrl) {
            var parentLocation = parameters.parentUrl;
        }

        if (parentLocation && parentWindow){ 
            parentWindow.postMessage(data, parentLocation);
        }
    };

    i4goIframeSaveUserCard.onSuccess = function(form, data) {

        __setCreditCardPaymentInfo(data);
        __postToParent(data);

        var cardMustBeSaved = $(form).find('[name=card_on_file]').val();
        if (!cardMustBeSaved) {
            window.close();
            return;
        }

        var url = '/i4go/save-user-card';

        data.ca_token = $(form).find('[name=ca_token]').val();

        $.caPost(
            url,
            data,
            function(response) {
                if (response.status === 1) {
                    window.close();
                } else {
                    $.caAlert(response.error);
                }
            },
            'json',
            true
        );
    };
    
    i4goIframeSaveUserCard.onFailure = function() {
        $.caAlert('Something went wrong... Please try again later.');
    };

})(jQuery);

export default i4goIframeSaveUserCard;
